import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Clock, Coins, Lightning, Sparkle } from "@phosphor-icons/react";

const PRIORITY_BADGE = {
  low: "bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
  medium: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200",
  high: "bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200",
  critical: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200",
};

const STATUS_TEXT = {
  open: "Open",
  applied: "Applied",
  assigned: "Assigned",
  in_progress: "In Progress",
  review: "In Review",
  completed: "Completed",
  scored: "Closed",
  closed: "Closed",
  rework_required: "Rework",
  blocked: "Blocked",
  draft: "Draft",
  pending_approval: "Pending",
  cancelled: "Cancelled",
};

export default function TaskCard({ task, departmentName }) {
  return (
    <Link
      to={`/tasks/${task.task_id}`}
      data-testid={`task-card-${task.task_id}`}
      className="group block border border-border bg-background hover:-translate-y-0.5 hover:shadow-sm transition-all rounded-sm"
    >
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-sm font-semibold leading-snug tracking-tight line-clamp-2 group-hover:underline underline-offset-4">
            {task.title}
          </h3>
          <span className={`text-[10px] uppercase tracking-[0.15em] font-bold px-2 py-1 rounded-sm whitespace-nowrap ${PRIORITY_BADGE[task.priority] || PRIORITY_BADGE.medium}`}>
            {task.priority}
          </span>
        </div>
        <p className="text-xs text-zinc-600 dark:text-zinc-400 line-clamp-2">{task.description}</p>
        <div className="flex flex-wrap gap-1.5">
          {(task.required_skills || []).slice(0, 4).map((s) => (
            <Badge key={s} variant="outline" className="rounded-sm text-[10px] font-mono uppercase tracking-wider">
              {s}
            </Badge>
          ))}
        </div>
        <div className="grid grid-cols-3 gap-2 pt-2 border-t border-border text-xs">
          <div className="flex items-center gap-1.5 text-zinc-500">
            <Clock size={12} />
            <span>{task.effort_hours}h</span>
          </div>
          <div className="flex items-center gap-1.5 text-zinc-500">
            <Sparkle size={12} />
            <span>{task.reward_points} pts</span>
          </div>
          <div className="flex items-center gap-1.5 text-[#E1252A] font-semibold">
            <Coins size={12} weight="fill" />
            <span className="font-mono">{task.credit_cost}</span>
          </div>
        </div>
        <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.15em] text-zinc-500 pt-1">
          <span>{departmentName || "—"}</span>
          <span>{STATUS_TEXT[task.status] || task.status}</span>
        </div>
      </div>
    </Link>
  );
}
